






















import {Component, Prop, Mixins} from 'vue-property-decorator';
import DialogMixin from '@/mixins/dialog/DialogMixin';

@Component({
    inheritAttrs: false,
})
export default class CConfirmDialog extends Mixins(DialogMixin) {
    get text() {
        return this.data ? this.data.text : '';
    }
    onOk() {
        if (typeof this.options.callback === 'function') this.options.callback();
        this.close();
    }
}
